// import { L10nModule } from 'bernie-common';
import { L10nModule } from 'bernie-l10n';

export const localization = (locale: string): L10nModule => {
  const mod = new L10nModule();

  mod.current = locale;
  // tslint:disable-next-line: non-literal-require
  mod.globalize = require(`bernie-cars-shopping-web-localization/dist/bundle-${locale}`);

  return mod;
};
